import React from 'react';

/** A wall bar. Placed by Board; can also render standalone for legends. */
export function Wall({ orientation = 'h', placed = true, ghost = false, style = {} }) {
  const horizontal = orientation === 'h';
  const bg = ghost
    ? 'var(--accent)'
    : 'linear-gradient(180deg, var(--wall-hi), var(--wall-fill) 60%, var(--wall-lo))';
  return (
    <span
      style={{
        display: 'block',
        width: horizontal ? '100%' : '100%',
        height: '100%',
        borderRadius: 'var(--radius-sm)',
        background: bg,
        opacity: ghost ? 0.55 : 1,
        boxShadow: ghost
          ? '0 0 0 2px var(--accent)'
          : '0 3px 8px rgba(20,14,8,.4), inset 0 1.5px 0 rgba(255,255,255,.22), inset 0 -2px 3px rgba(0,0,0,.3)',
        transition: 'opacity var(--dur-fast)',
        ...style,
      }}
    />
  );
}
